import { useQuery } from "@tanstack/react-query";
import { callWithAuth, getAllCourseTopics, getAllCourseLevels } from "@/api/Api";

export function useCourseFilters() {
  // Fetch topics
  const {
    data: topicsData,
    isLoading: topicsLoading,
    error: topicsError,
  } = useQuery({
    queryKey: ["courseTopics"],
    queryFn: () => callWithAuth(getAllCourseTopics),
  });

  // Fetch levels
  const {
    data: levelsData,
    isLoading: levelsLoading,
    error: levelsError,
  } = useQuery({
    queryKey: ["courseLevels"],
    queryFn: () => callWithAuth(getAllCourseLevels),
  });

  return {
    topicsData,
    levelsData,
    topicsLoading,
    levelsLoading,
    topicsError,
    levelsError,
  };
} 